import { useSelector } from 'react-redux'
import { languages } from '../../../configs/language'
import EventEmitter, { SET_SINGLE_DATE } from '../../helpers/EventEmitter'
import { Element } from '../html/element'
import { Icon } from '../html/icon'
import { ButtonSubmit } from './ButtonSubmit'
import { enMonthsSelect, viMonthsSelect } from './constants'
import {
  checkMaxMonth,
  checkMaxYear,
  checkMinMonth,
  checkMinYear,
} from './helper'
import classes from './index.module.scss'

const SelectMonth = ({
  stateMonthYear,
  setStateMonthYear,
  enableSelectYear,
  disableSelectMonth,
  minMonth,
  minYear,
  maxMonth,
  maxYear,
  minDate,
  maxDate,
}) => {
  const locale = useSelector((state) => state.i18n.locale)

  const nextYear = () => {
    const newYear = stateMonthYear.year + 1

    const isValidYear = checkMaxYear(newYear, maxYear)

    const isValidMonth = checkMaxMonth(
      newYear,
      maxYear,
      stateMonthYear.month,
      maxMonth,
    )

    const newMonth = isValidMonth ? stateMonthYear.month : maxMonth

    if (isValidYear) {
      setStateMonthYear({ month: newMonth, year: newYear })
    }
  }

  const backYear = () => {
    const newYear = stateMonthYear.year - 1

    const isValidYear = checkMinYear(newYear, minYear)

    const isValidMonth = checkMinMonth(
      newYear,
      minYear,
      stateMonthYear.month,
      minMonth,
    )

    const newMonth = isValidMonth ? stateMonthYear.month : minMonth

    if (isValidYear) {
      setStateMonthYear({ month: newMonth, year: newYear })
    }
  }

  const months = locale === languages.en ? enMonthsSelect : viMonthsSelect

  return (
    <Element
      style={{ backgroundColor: '#FFFFFF' }}
      className={classes.calendarContainer}
    >
      <div
        className={`${classes.monthYearContainer} ${classes.pd0} ${classes.monthYearSingle}`}
      >
        <div
          className={`${classes.monthYear} justifyContentBetween ${classes.w100}`}
        >
          <Icon
            className="icon-arrow-left"
            style={{ fontSize: 10 }}
            onClick={backYear}
          />
          <Element
            onClick={enableSelectYear}
            className={classes.monthYearDisplay}
            style={{ fontSize: 14 }}
          >
            {stateMonthYear.year}
          </Element>
          <Icon
            className="icon-arrow-right"
            style={{ fontSize: 10 }}
            onClick={nextYear}
          />
        </div>
      </div>
      <div className={classes.monthYearCalendarContainer}>
        {months.map((month, index) => {
          const active = stateMonthYear.month === index

          const isValidMonth =
            checkMinMonth(stateMonthYear.year, minYear, index, minMonth) &&
            checkMaxMonth(stateMonthYear.year, maxYear, index, maxMonth)

          const classMonth = isValidMonth
            ? `${classes.month} ${active ? classes.monthActive : ''}`
            : classes.monthDisable

          const chooseMonth = isValidMonth
            ? () => {
                const newDate = new Date(stateMonthYear.year, index, 1)

                setStateMonthYear({ ...stateMonthYear, month: index })

                EventEmitter.dispatch(
                  SET_SINGLE_DATE,
                  minDate && minDate > newDate
                    ? minDate
                    : maxDate && maxDate < newDate
                    ? maxDate
                    : newDate,
                )

                disableSelectMonth()
              }
            : undefined

          return (
            <div key={index} onClick={chooseMonth} className={classMonth}>
              <span>{month}</span>
            </div>
          )
        })}
        {months.slice(0, 4).map((month, index) => (
          <div key={index} className={classes.monthDisable}>
            <span>{month}</span>
          </div>
        ))}
      </div>
      <div className={classes.buttonContainer}>
        <ButtonSubmit submit={disableSelectMonth} />
      </div>
    </Element>
  )
}

export default SelectMonth
